<div class="maintenance-page">
  <main class="maintenance-card">
    <div class="maintenance-medallion" aria-hidden="true">
      <span class="maintenance-pulse"></span>
      <fa-icon [icon]="faWrench"></fa-icon>
    </div>

    <h1 class="maintenance-title">Maintenance en cours</h1>

    <p class="maintenance-lead">
      Le Portail client est momentanément indisponible le temps d'une opération de maintenance.
    </p>
    <p class="maintenance-text">
      Inutile d'actualiser la page :<br/>
      elle se met à jour automatiquement.<br/>
      L'accès au Portail sera rétabli dès la fin de la maintenance.
    </p>

    <img class="maintenance-logo" src="assets/libriciel_color.svg" alt="Libriciel"/>
  </main>
</div>
